"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { applyTheme, getThemeForRoute, SectionTheme } from "@/lib/theme/section-themes";

export function useSectionTheme() {
  const pathname = usePathname();
  const [currentTheme, setCurrentTheme] = useState<SectionTheme | null>(null);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    // Start transition
    setIsTransitioning(true);

    // Get theme for current route
    const theme = getThemeForRoute(pathname || "");

    // Apply theme with a slight delay for smoother transition
    const transitionTimeout = setTimeout(() => {
      applyTheme(theme);
      setCurrentTheme(theme);

      // End transition after CSS transitions complete
      setTimeout(() => {
        setIsTransitioning(false);
      }, 300);
    }, 50);

    return () => clearTimeout(transitionTimeout);
  }, [pathname]);

  return {
    theme: currentTheme,
    isTransitioning,
  };
}
